// constants.js
import SIDEBAR_BOX_IMG from '../../../../assets/images/comniqAI/comniqai-smalllogo.svg';
import COMNIQ_LOGO from '../../../../assets/images/comniqAI/comniq-logo-dark.svg';

export const INITIAL_FORM_VALUE = {
  name: '',
  email: '',
  phone_number: '',
};

export const INITIAL_WELCOME_DETAILS = {
  welcome_msg: null,
  lead_choice: null,
  lead_status: false,
  generate_lead_choice: null,
  create_lead_choice: null,
  is_calendar: false,
  lead_form: false,
  is_powered_by_visible: false,
};

export const INITIAL_UI_STATE = {
  openChatbox: false,
  loader: false,
  showForm: false,
  showCalendar: { show: false, link: '' },
  welBubblePopup: false,
  deleteConfirmPopup: false,
  showPublishWarning: false,
  isDropdownOpen: false,
  hoveredIndex: null,
  copied: false,
  showPrivacy: true,
  hideButtons: false,
  isButtonDisabled: false,
  isLeadButtonHide: false,
  showFormButton: false,
  customDisabled: false,
  retrainPopup: false,
};

export const DEFAULT_IMAGES = {
  SIDEBAR_BOX_IMG: SIDEBAR_BOX_IMG,
  COMNIQ_LOGO: COMNIQ_LOGO,
  DEFAULT_LAUNCHER: 'https://api.comniqai.com/media/default_icon/chat-message.svg',
};

export const SESSION_ID_LENGTH = 8;
export const COPY_FEEDBACK_TIMEOUT = 3000;
export const TIMESTAMP_UPDATE_INTERVAL = 60000;
